if (!customElements.get('load-more')) {
  class LoadMore extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addLoadMoreListeners();
    }

    addLoadMoreListeners() {
      const readMoreBtnEl = this.querySelector('.js-read-more');

      readMoreBtnEl.addEventListener('click', this.onReadMoreClick.bind(this));
    }

    onReadMoreClick(event) {
      const cutContentEl = this.querySelector('.js-cut-content');
      const fullContentEl = this.querySelector('.js-full-content');

      cutContentEl.classList.toggle('hidden');
      fullContentEl.classList.toggle('hidden');
    }
  }

  customElements.define('load-more', LoadMore);
}
